<h2 mat-dialog-title class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>{{ isEditMode ? 'Edit Training and Education' : 'Add Training and Education' }}</h2>
<mat-dialog-content class="dialog-content">
  <div>
    <mat-form-field appearance="fill" class="form-field">
      <mat-label>Type</mat-label>
      <mat-select placeholder="Select type" [value]="selectedTrainingAndEducation?.type" (selectionChange)="onTypeSelected($event)">
        @for (type of trainingEducationTypes; track type.value) {
          <mat-option [value]="type.value">
            {{ type.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="autocomplete-row">
    <app-autocomplete-select
      #educationFieldAutocomplete
      [isFullWidth]="true"
      [searchFunction]="searchEducationFields"
      [maxResults]="1000"
      displayProperty="name"
      label="Find an education field"
      placeholder="Type at least 3 characters to search..."
      (optionSelected)="onEducationFieldSelected($event)">
    </app-autocomplete-select>
    @if (canAddNewEducationField) {
      <button
        mat-mini-fab
        color="primary"
        type="button"
        class="add-inline-button"
        matTooltip="Add as a new education field"
        (click)="onAddNewEducationField()">
        <mat-icon>add</mat-icon>
      </button>
    }
  </div>
  <div class="autocomplete-row">
    <app-autocomplete-select
      #universityAutocomplete
      [isFullWidth]="true"
      [searchFunction]="searchUniversities"
      [maxResults]="1000"
      displayProperty="name"
      label="Find a university"
      placeholder="Type at least 3 characters to search..."
      (optionSelected)="onUniversitySelected($event)">
    </app-autocomplete-select>
    @if (canAddNewUniversity) {
      <mat-form-field appearance="fill" class="new-entity-country">
        <mat-label>Country</mat-label>
        <mat-select [formControl]="newUniversityCountryControl" [compareWith]="compareCountryById">
          @for (country of countries; track country.id) {
            <mat-option [value]="country">{{ country.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button
        mat-mini-fab
        color="primary"
        type="button"
        class="add-inline-button"
        [disabled]="!newUniversityCountryControl.value"
        matTooltip="Add as a new university"
        (click)="onAddNewUniversity()">
        <mat-icon>add</mat-icon>
      </button>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button type="button" class="nrg-error-raised-button" (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" [disabled]="!isFormValid" (click)="onConfirm()">{{ isEditMode ? 'Save' : 'Add' }}</button>
</mat-dialog-actions>
